import { BoardCardType } from "@fry/boards/lib";
import { TextCardViewComponent } from "./text-card.view.component";
import { TextCardSettingsComponent } from "./text-card.settings.component";

export interface TextCardOptions {
    title: string
    paragraph: string
}

export const TextCard: BoardCardType = {
    name: 'text',
    title: $localize `Text`,
    viewComponent: TextCardViewComponent,
    editComponent: TextCardSettingsComponent,
}
